import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

const AdminUsersHeader = ({
  usersVisible,
  usersTotal,
  usersActive,
  usersInactive,
  usersDeactivated,
  loading,
  history,
}) => {
  const intl = useIntl();

  return (
    <header className="page-header">
      <h3>
        {intl.formatMessage({ defaultMessage: 'Users' })}
      </h3>
      <div className="header-actions users-actions">
        <div className="items-displaying users-displaying">
          {!loading && (
            <span>
              {intl.formatMessage(
                { defaultMessage: '{usersVisible} of {usersTotal} users' },
                { usersVisible, usersTotal },
              )}

              <span className="sub">
                {intl.formatMessage(
                  { defaultMessage: '{nbsp}({usersActive} active, {usersInactive} inactive, {usersDeactivated} deactivated)' },
                  {
                    usersActive,
                    usersInactive,
                    usersDeactivated,
                    nbsp: ' ',
                  },
                )}
              </span>
            </span>
          )}
        </div>
        <div className="button-wrapper">
          <Button color="primary" onClick={() => { history.push('/admin/settings/users/add'); }}>
            <i className="fas fa-plus" />
            <span>
              {intl.formatMessage({ defaultMessage: 'Invite user' })}
            </span>
          </Button>
        </div>
      </div>
    </header>
  );
};

AdminUsersHeader.propTypes = {
  history: PropTypes.object.isRequired,
  usersVisible: PropTypes.string.isRequired,
  usersTotal: PropTypes.number.isRequired,
  usersActive: PropTypes.number.isRequired,
  usersInactive: PropTypes.number.isRequired,
  usersDeactivated: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default withRouter(AdminUsersHeader);
